import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

export class _PisCofinsStore {
  obs = observable({
    pis_cofins: [] as any,
    loading: false as boolean
  })

  async handleLoadPisCofins() {

    let resp = await api.get("/api/codigos/pis-cofins")

    this.obs.pis_cofins = []

    if (resp.data.length) {

      this.obs.pis_cofins = resp.data

    }
    
  }

  get(codigo: any): any {

    return this.obs.pis_cofins.find(x => x.codigo == codigo);

  }

  async handleCreatePisCofins(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/pis-cofins/create", data)

    if (resp.data.ok) {

      toast.success('PIS-COFINS criado com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

  async handleUpdatePisCofins(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/pis-cofins/update", data)

    if (resp.data.ok) {

      toast.success('PIS-COFINS atualizado com sucesso!', {});

      return true

    } else {

      toast.warning(resp.data.msg, {});

    }

    return false

  }

  async handleDeletePisCofins(id: string) {

    let resp = await api_adm.delete(`/api/admin/codigos/pis-cofins/${id}`)

    if (resp.data.ok) {

      toast.success('PIS-COFINS deletado com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

}

export const PisCofinsStore = new _PisCofinsStore();
